import React from "react";
import "./TermsOfService.css";
import LegalLayout from "../components/legalLayout/LegalLayout";

const TermsOfService = () => {
  return (
    <LegalLayout>
      <div className="content">
        <h1 className="main-title">Terms of Service</h1>
        <p className="effective-date">
          Effective Date: 11/17/2025
        </p>
        <h1>Welcome to LifeWink. Thanks for joining us.</h1>
        <p>
          This policy, which we refer to us as our "Terms of Use" is a binding contract between you
          and LifeWink, LLC ("LifeWink," "Company," "we," or "us"). It establishes certain rules you
          must follow when accessing the LifeWink website and app ("LifeWink" or the "Service").
        </p>
        <p>
          Please read the Terms of Use carefully. By accessing or using the Service, you accept and
          agree to be bound and abide by these Terms of Use and our Privacy Policy, found at{" "}
          <a href="https://portal.lifewink.com/privacy-policy">https://portal.lifewink.com/privacy-policy</a>, incorporated herein by reference. If you do not want to
          agree to these Terms of Use or the Privacy Policy, you must not access or use the Service.
        </p>
        <p>
          The Service is offered and available to users who are 18 years of age or older. By using the
          Service, you represent and warrant that you are of legal age to form a binding contract with
          LifeWink and meet all of the foregoing eligibility requirements. If you do not meet all of these
          requirements, you must not access or use the Service.
        </p>
        <p style={{ fontWeight: "bold", marginTop: "1rem", marginBottom: "1rem" }}>
          ARBITRATION NOTICE: YOU AGREE THAT DISPUTES BETWEEN YOU AND US WILL
          BE RESOLVED BY BINDING, INDIVIDUAL ARBITRATION AND YOU WAIVE YOUR
          RIGHT TO PARTICIPATE IN A CLASS ACTION LAWSUIT OR CLASS-WIDE
          ARBITRATION. WE EXPLAIN SOME EXCEPTIONS AND HOW YOU CAN OPT OUT OF
          ARBITRATION BELOW.
        </p>
        <div className="container-text">
          <h1>Changes to the Terms of Use</h1>
          <p>
            We may revise and update these Terms of Use from time to time as our business and
            environment evolve. All changes to the Terms of Use are effective immediately when we
            post them and apply to all access to and use of the Service thereafter. If we consider a
            revision to be material, we will notify you. If you reside in the EU, we will notify you of
            revisions at least 15 days before those changes take effect.
          </p>
          <p>
            Your continued use of the Service following the posting of revised Terms of Use means that
            you accept and agree to the changes. You are expected to check this page from time to time
            so you are aware of any changes, as they are binding on you.
          </p>
        </div>
        <div className="container-text">
          <h1>Content</h1>
          <p>
            The Service and its entire contents, features, and functionality (including but not limited to all
            information, software, text, displays, images, video, and audio, and the design, selection,
            and arrangement thereof) are owned by the Company, its licensors, or other providers of
            such material and are protected by United States and international copyright, trademark,
            patent, trade secret, and other intellectual property or proprietary rights laws.
          </p>
          <p>
            These Terms of Use permit you to use the Service for your personal, non-commercial use
            only.
          </p>
          <p>
            If you interact with the Service as a Beloved or a Recipient (using the AI features), you are
            solely responsible for any content that you upload, store, or share with the Service ("Your
            Content"). Your Content includes: (i) all content that is uploaded, stored, or shared with the
            Service, or otherwise made available to the Service on your behalf,; (ii) all content generated
            or otherwise output from the Service ; and (iii) any materials incorporating your Image Rights
            (defined below).
          </p>
          <p>
            LifeWink does not make any claim to Your Content but requires you to represent that you
            have all necessary rights to use Your Content, that it doesn't infringe or violate any third
            party's rights, and that it complies with these Terms of Use, including our Community
            Guidelines.
          </p>
          <p>
            By sharing Your Content with the Service, you grant LifeWink, our service providers, and any
            designated Recipients a license to use it. This means that you grant us a non-exclusive,
            worldwide, royalty-free, irrevocable, sub-licensable, perpetual license to use, display, edit,
            modify, reproduce, distribute, store, and prepare derivative works of Your Content. This
            allows us to provide the Service and our services in accordance with your instructions.
          </p>
          <p>
            If, for example, you create a LifeWink video message that is designated to be shared with a
            specific Recipient (like your grandson), we have the right to store and sublicense Your
            Content incorporated in that LifeWink on our website, our app, our servers, with our service
            providers that help us provide the Service (like our hosting providers and/or data centers),
            and to ultimately share it with your grandson. Without this authorization, we'd be unable to
            provide the Service to you.
          </p>
        </div>
        <div className="container-text">
          <h1>Your Image Rights</h1>
          <p>
            To the extent you share your name, image, likeness, voice, appearance, signature, and other
            personal characteristics, with LifeWink (collectively, your "Image Rights"), you grant us and
            third parties a license to use your Image Rights in connection with our provision of the
            Service. This license also allows us to use all materials incorporating your Image Rights (like
            an audio LifeWink containing your voice or a video LifeWink containing your image and
            voice) in perpetuity, in any medium or format whatsoever, in connection with the Service
            without further consent from or royalty, payment, or other compensation to you.
          </p>
          <p>
            When you share your Image Rights with LifeWink by creating LifeWinks or providing
            personal characteristics to us, you are not only giving us permission to store and process it
            on our website, app, servers and service providers, but also to share it with third party
            recipients of your LifeWink (on your instructions).
          </p>
        </div>
        <div className="container-text">
          <h1>AI Features</h1>
          <p>
            The Service may offer certain features, functionalities, or components that use automated
            intelligence technology (the "AI Features"), like AI Chat and AI Voice that allow you to create
            voice and chat models that sound like you, trained using the memories, stories, and content
            you provide for the model to reference in future interactions with Recipients.
          </p>
          <p>
            You hereby grant to LifeWink a non-exclusive right to use Your Content to train, retrain, tune,
            validate, modify, update, or otherwise improve the AI Features solely for your benefit. For
            clarity, LifeWink will never use Your Content to train its Services generally for the benefit
            other Beloved users.
          </p>
        </div>
        <div className="container-text">
          <h1>Inappropriate Content</h1>
          <p>
            LifeWink's mission is to create and spread love. With that in mind, there are certain types of
            content we don't want sent through the Service (for legal reasons or otherwise) as set forth
            in our Community Guidelines.
          </p>
          <p>
            We can remove any content or information you share on the Service or terminate your
            account with us if we believe that it violates these Terms of Use, or if we are permitted or
            required to do so by law.
          </p>
        </div>
        <div className="container-text">
          <h1>Trademarks</h1>
          <p>
            The Company name, the Company logo, and all related names, logos, product and service
            names, designs, and slogans are trademarks of the Company or its affiliates or licensors.
            You must not use such marks without the prior written permission of the Company. All other
            names, logos, product and service names, designs, and slogans used by the Service are the
            trademarks of their respective owners.
          </p>
        </div>
        <div className="container-text">
          <h1>Subscriptions</h1>
          <p>
            We provide a few different service options for our users. Some LifeWink services are
            provided free of charge, while others require payment before they can be accessed (our
            "Paid Subscriptions"). Subject to these Terms of Use, users who purchase a Paid
            Subscription may access that Paid Subscription for their own personal use from the moment
            they submit their payment details successfully to LifeWink, or applicable third party, and
            complete the checkout process.
          </p>
          <p>
            Unless otherwise indicated, Paid Subscriptions continue for the subscription period set forth
            on our website ("Subscription Period"). You will be billed at the frequency selected during the
            checkout process (e.g., monthly or annually) and all subscription fees are non-refundable
            and non-cancellable during the Subscription Period.
          </p>
          <p>
            At the expiration of the Subscription Period, your subscription will automatically renew for the
            same Subscription Period unless you indicate your desire to terminate.
          </p>
          <p>
            We reserve the right to modify the features and content we provide as part of our Paid
            Subscriptions from time to time and for any reason.
          </p>
        </div>
        <div className="container-text">
          <h1>Trials</h1>
          <p>
            From time to time, we may offer trials of Paid Subscriptions without payment or at a reduced
            rate ("Trial") for a specified period (the "Trial Period"). Each Trial is made available subject to
            how it is advertised. For some Trials, you may be required to provide your payment details to
            start the Trial. By providing such details you agree that LifeWink may automatically begin
            charging you for the Paid Subscription on the first day following the end of the Trial on the
            billing frequency and Subscription Period selected by you during the Trial checkout process,
            unless you cancel before the end of the Trial Period.
          </p>
          <p>
            Unless cancelled before the end of the Trial Period, you will automatically become a
            subscriber to the particular Paid Subscription that you chose to sign up to under the Trial and
            the payment method you provided will automatically be charged the then-current recurring
            price on the first day following the end of the Trial on a monthly recurring basis or other
            interval that we disclose to you in advance. <strong>IF YOU DO NOT WANT TO PAY THIS
            CHARGE, YOU MUST CANCEL BEFORE THE END OF THE TRIAL BY FOLLOWING THE
            STEPS DESCRIBED HERE.</strong>
          </p>
        </div>
        <div className="container-text">
          <h1>Community Guidelines</h1>
          <p>
            When using the Service, make sure you take appropriate measures to protect the security of
            your account with us, including your login credentials. You are responsible for any activity
            performed through your account or using your login credentials.
          </p>
          <p>
            You may use the Service only for lawful purposes and in accordance with these Terms of
            Use and the requirements set forth below (our "Community Guidelines"). You agree not to
            use the Service:
          </p>
          <ul>
            <li>
              In any way that violates any applicable federal, state, local, or international law or regulation
              (including, without limitation, any laws regarding the export of data or software to and from
              the US or other countries).
            </li>
            <li>
              To impersonate or attempt to impersonate the Company, a Company employee, another
              user, or any other person or entity (including, without limitation, by using email addresses
              associated with any of the foregoing).
            </li>
            <li>
              To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the
              Service, or which, as determined by us, may harm the Company or users of the Service, or
              expose them to liability.
            </li>
          </ul>
          <p>Additionally, you agree not to:</p>
          <ul>
            <li>
              Use the Service in any manner that could disable, overburden, damage, or impair the site or
              app or interfere with any other party's use of the Service, including their ability to engage in
              real time activities through the Service.
            </li>
            <li>
              Use any robot, spider, or other automatic device, process, or means to access the Service
              for any purpose, including monitoring or copying any of the material accessible by the
              Service.
            </li>
            <li>
              Use any manual process to monitor or copy any of the material on the Service, or for any
              other purpose not expressly authorized in these Terms of Use, without our prior written
              consent.
            </li>
            <li>
              Use any device, software, or routine that interferes with the proper working of the Service.
            </li>
            <li>
              Introduce any viruses, Trojan horses, worms, logic bombs, or other material that is malicious
              or technologically harmful.
            </li>
            <li>
              Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the
              Service, the server on which the Service is stored, or any server, computer, or database
              connected to the Service.
            </li>
            <li>
              Attack the Service via a denial-of-service attack or a distributed denial-of-service attack.
            </li>
            <li>
              Otherwise attempt to interfere with the proper working of the Service.
            </li>
          </ul>
        </div>
        <div className="container-text">
          <h1>Information About You</h1>
          <p>
            All information we collect via the Service is subject to our Privacy Policy{" "}
            <a href="https://portal.lifewink.com/privacy-policy">https://portal.lifewink.com/privacy-policy</a>. By using the Service, you consent to all actions taken by
            us with respect to your information in compliance with the Privacy Policy.
          </p>
        </div>
        <div className="container-text">
          <h1>Digital Millennium Copyright Act</h1>
          <p>
            The Digital Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright
            owners who believe that material appearing on the Internet infringes their rights under U.S.
            copyright law. The local applicable legislation in your country, if pertinent, is also enforced. It
            is our policy, in appropriate circumstances and at our discretion, to disable and/or terminate
            the accounts of users who repeatedly infringe or are repeatedly charged with infringing the
            copyrights or other intellectual property rights of others.
          </p>
          <p>
            If you believe that your work has been copied and posted on the Service in a way that
            constitutes copyright infringement, please provide our copyright agent with the following
            information: an electronic or physical signature of the copyright owner or of the person
            authorized to act on behalf of the owner of the copyright interest; a description and photo of
            the copyrighted work that you claim has been infringed; a description of where the material
            that you claim is infringing is located on the Service (the URL); your address, telephone
            number, e-mail address; a written statement by you that you have a good faith belief that the
            disputed use is not authorized by the copyright owner, its agent, or the law; and a statement
            by you, made under penalty of perjury, that the above information in your notice is accurate
            and that you are the copyright owner or are authorized to act on the copyright owner's
            behalf.
          </p>
          <p>
            Notification by a copyright owner or a person authorized to act on such copyright owner's
            behalf that fails to comply substantially with requirements of the DMCA and equivalent local
            copyright legislation shall not be considered sufficient notice and shall not be deemed to
            confer upon us actual knowledge of facts or circumstances from which infringing material or
            acts are evident. Our copyright agent for notice of claims of copyright infringement can be
            reached as follows: 391 Belle Foret Drive, Lake Bluff, IL 60044.
          </p>
        </div>
        <div className="container-text">
          <h1>Links from the Service</h1>
          <p>
            If the Service contains links to other sites and resources provided by third parties, these links
            are provided for your convenience only. This includes links contained in advertisements,
            including banner advertisements and sponsored links. We have no control over the contents
            of those sites or resources and accept no responsibility for them or for any loss or damage
            that may arise from your use of them. If you decide to access any of the third-party websites
            linked to the Service, you do so entirely at your own risk and subject to the terms and
            conditions of use for such websites.
          </p>
        </div>
        <div className="container-text">
          <h1>Termination</h1>
          <p>
            You may terminate your account with LifeWink at any time from your account settings. If you
            decide to permanently close your account with LifeWink, you will not be able to access Your
            Content once your account is terminated.
          </p>
          <p>
            LifeWink may terminate or suspend your account (and any accounts LifeWink determines
            are related to your account) and your access to the Service if we suspect that you, Your
            Content, or your use of the Service violate our Terms. If we do so, we'll let you know that
            your account has been terminated or suspended, unless you've repeatedly violated our
            Terms of Use, or we have legal or regulatory reasons preventing us from notifying you.
          </p>
          <p>
            LifeWink also reserves the right to change, suspend, or discontinue any of the services or
            functionalities facilitated by the Service for you, any or all users, at any time, for any reason.
            We will not be liable to you for the effect that any changes to the Service may have on you.
          </p>
        </div>
        <div className="container-text">
          <h1>Disclaimer of Warranties</h1>
          <p>
            You may receive LifeWinks containing materials or content that you find offensive or
            inappropriate while using the Service. We make no representations concerning any content
            contained in any LifeWink and created by Members through the Service. LifeWink is not
            responsible for the accuracy, copyright compliance, legality, or decency of content posted by
            Members that you accessed through the Service. You release us from all liability relating to
            that content.
          </p>
          <p>
            We work hard to ensure that LifeWink improves the quality of life of all of our users, but
            sometimes things don't work as well as intended. TO THE FULLEST EXTENT PROVIDED
            BY LAW, WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A
            DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER
            TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER
            EQUIPMENT, COMPUTER PROGRAMS, DATA, OR OTHER PROPRIETARY MATERIAL
            DUE TO YOUR USE OF THE SERVICE OR ITEMS OBTAINED THROUGH THE SERVICE
            OR YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE
            LINKED TO IT.
          </p>
          <p>
            YOUR USE OF THE SERVICE, ITS CONTENT, AND ANY ITEMS OBTAINED THROUGH
            THE SERVICE IS AT YOUR OWN RISK. THE SERVICE, ITS CONTENT, AND ANY ITEMS
            OBTAINED THROUGH THE SERVICE ARE PROVIDED ON AN "AS IS" AND "AS
            AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR
            IMPLIED. NEITHER LIFEWINK NOR ANY PERSON ASSOCIATED WITH LIFEWINK
            MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE
            COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY
            OF THE SERVICE OR YOUR CONTENT. WITHOUT LIMITING THE FOREGOING,
            NEITHER LIFEWINK NOR ANYONE ASSOCIATED WITH LIFEWINK REPRESENTS OR
            WARRANTS THAT THE SERVICE, ITS CONTENT, OR ANY ITEMS OBTAINED THROUGH
            THE WEBSITE WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED,
            THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT
            MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS,
            OR THAT THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
          </p>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, LIFEWINK HEREBY DISCLAIMS ALL
            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
            OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
            MERCHANTABILIT Y, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR
            PURPOSE. THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT
            BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
          </p>
        </div>
        <div className="container-text">
          <h1>Limitation on Liability</h1>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, LIFEWINK SHALL NOT BE LIABLE
            FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE
            DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED
            DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL OR OTHER
            INTANGIBLE LOSSES. IN NO EVENT WILL THE COLLECTIVE LIABILITY OF THE
            LIFEWINK AND ITS SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, AND
            DIRECTORS, TO ANY PARTY (REGARDLESS OF THE FORM OF ACTION, WHETHER IN
            CONTRACT, TORT, OR OTHERWISE) EXCEED $100.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED
            OR LIMITED UNDER APPLICABLE LAW.
          </p>
        </div>
        <div className="container-text">
          <h1>Indemnification</h1>
          <p>
            If LifeWink gets sued or receives a claim, notice, or demand because of something that you
            did (or failed to do), you agree to defend and indemnify us. That means, without limitation,
            that you'll defend, reimburse, compensate, and hold LifeWink (including any of our
            employees, officers, directors, and agents) harmless from any allegation, claim, demand,
            lawsuit, loss, liability, or expense of any kind (including reasonable attorneys' fees) that
            arises from your actions, your use (or misuse) of the Service, your breach of the Terms of
            Use, and/or your actual or alleged violation of any law or any third party's rights. We reserve
            the right to handle our legal defense however we see fit, even if you are indemnifying us, in
            which case you agree to cooperate with us so we can execute our strategy.
          </p>
          <p>
            And if you get sued by another LifeWink user or third party related to your use of the Service,
            you release LifeWink from any claims, demands, and damages arising out of disputes with
            such user or third party.
          </p>
        </div>
        <div className="container-text">
          <h1>Arbitration</h1>
          <p>
            Except as provided below, you and we agree that any cause of action, legal claim, or dispute
            between you and us arising out of or related to these Terms of Use ("claim(s)") must be
            resolved by arbitration on an individual basis. Class actions and class arbitrations are not
            permitted; you and we may bring a claim only on your own behalf and cannot seek relief that
            would affect other Lifewink users. If there is a final judicial determination that any particular
            claim (or a request for particular relief) cannot be arbitrated in accordance with this
            provision's limitations, then only that claim (or only that request for relief) may be brought in
            court. All other claims (or requests for relief) remain subject to this provision.
          </p>
          <p>
            Instead of using arbitration, you or we can bring claims in your local "small claims" court, if
            the rules of that court will allow it. If you don't bring your claims in small claims court (or if
            you or we appeal a small claims court judgment to a court of general jurisdiction), then the
            claims must be resolved by binding, individual arbitration. The American Arbitration
            Association will administer all arbitrations under its Consumer Arbitration Rules. You and we
            expressly waive a trial by jury.
          </p>
          <p>
            The following claims don't have to be arbitrated and may be brought in court: disputes
            related to intellectual property (like copyrights and trademarks), violations of our Terms of
            Use, or efforts to interfere with the Service or engage with the Service in unauthorized ways.
            In addition, issues relating to the scope and enforceability of the arbitration provision are for
            a court to decide.
          </p>
          <p>
            This arbitration provision is governed by the Federal Arbitration Act.
          </p>
          <p>
            You can opt out of this provision within 30 days of the date that you agreed to these Terms of
            Use. To opt out, you must send your name, residence address, email address or phone
            number you use for your Lifewink account, and a clear statement that you want to opt out of
            this arbitration agreement, and you must send them here: 391 Belle Foret Drive, Lake Bluff,
            IL 60044.
          </p>
          <p>
            Before you commence arbitration of a claim, you must provide us with a written Notice of
            Dispute that includes your name, residence address, email address or phone number you
            use for your Lifewink account, a detailed description of the dispute, and the relief you seek.
            Any Notice of Dispute you send to us should be mailed to 391 Belle Foret Drive, Lake Bluff,
            IL 60044. Before we commence arbitration, we will send you a Notice of Dispute to the email
            address you use with your Lifewink account, or other appropriate means. If we are unable to
            resolve a dispute within thirty (30) days after the Notice of Dispute is received, you or we
            may commence arbitration.
          </p>
        </div>
        <div className="container-text">
          <h1>Governing Law and Jurisdiction</h1>
          <p>
            All matters relating to the Service and these Terms of Use, and any dispute or claim arising
            therefrom or related thereto (in each case, including non-contractual disputes or claims),
            shall be governed by and construed in accordance with the internal laws of the State of
            Illinois without giving effect to any choice or conflict of law provision or rule (whether of the
            State of Illinois or any other jurisdiction).
          </p>
          <p>
            Any legal suit, action, or proceeding arising out of, or related to, these Terms of Use or the
            Service (if not arbitrated or resolved in small claims court) shall be instituted exclusively in
            the federal courts of the United States or the courts of the State of Illinois, in each case
            located in the City of Chicago and County of Cook, although we retain the right to bring any
            suit, action, or proceeding against you for breach of these Terms of Use in your country of
            residence or any other relevant country. You waive any and all objections to the exercise of
            jurisdiction over you by such courts and to venue in such courts.
          </p>
        </div>
        <div className="container-text">
          <h2 style={{ margin: "0" }}>Your Comments and Concerns</h2>
          <p>
            All feedback, comments, requests for technical support, and other communications relating
            to these Terms of Use should be directed to: support@lifewink.com.
          </p>
        </div>
      </div>
    </LegalLayout>
  );
};

export default TermsOfService;
